module.exports = __webpack_public_path__ + "img/5847ca05bc140fd25454cf19d358a819.2d84c91a.png";